import {Button, Input, Option, Select, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import DateField from "../../system/dateField"
import "../../../style/datePicker.css"
import {Toaster} from "../../../helper/Toaster";
import Validator from "../../../helper/validator/Validator";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {
  submitBackOfficeAgentRequest,
  updateBackOfficeAgentRequestPersonalInfo
} from "../../../services/back_office/agent";
import {checkAll} from "../../../helper/validator/Check";

export function BackOfficeAgentRequestPersonalInfo({
                                                     activeStep,
                                                     setActiveStep,
                                                     agentRequest,
                                                     setAgentRequest,
                                                     handleNext,
                                                     handlePrev,
                                                     isFirstStep,
                                                     isLastStep,
                                                     allowedStep,
                                                     setAllowedStep,
                                                     person_id,
                                                   }) {

  const [id, setId] = useState(agentRequest?.id ?? null);
  const [name, setName] = useState(agentRequest?.name ?? "");
  const [family, setFamily] = useState(agentRequest?.family ?? "");
  const [fatherName, setFatherName] = useState(agentRequest?.father_name ?? "");
  const [nationalCode, setNationalCode] = useState(agentRequest?.national_code ?? "");
  const [birthDate, setBirthDate] = useState(agentRequest?.birth_date ?? "");
  const [gender, setGender] = useState(agentRequest?.gender ?? "male");
  const [personId, setPersonId] = useState(person_id);

  useEffect(() => {
    setPersonId(person_id);
  }, [person_id]);

  useEffect(() => {
    setAgentRequest(agentRequest || null);
    setId(agentRequest?.id ?? null);
    setName(agentRequest?.name ?? "");
    setFamily(agentRequest?.family ?? "");
    setFatherName(agentRequest?.father_name ?? "");
    setNationalCode(agentRequest?.national_code ?? "");
    setBirthDate(agentRequest?.birth_date ?? "");
    setGender(agentRequest?.gender ?? "male");
  }, [agentRequest, personId]);

  const save = async () => {
    const data = {
      id: id,
      name: name,
      family: family,
      father_name: fatherName,
      national_code: nationalCode,
      birth_date: birthDate,
      gender: gender,
      person_id: personId,
    };
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>);
      return
    }
    let result;

    if (!id) {
      result = await submitBackOfficeAgentRequest(data);
    } else {
      result = await updateBackOfficeAgentRequestPersonalInfo(data);
    }

    if (result.status === 200) {
      const {UserAgentRequest} = result.data;
      setAgentRequest(UserAgentRequest);
      // setActiveStep(1);
      if (allowedStep === 0) {
        setAllowedStep(1)
      }
      handleNext(1);
    }

  };

  useEffect(() => {
  }, [agentRequest]);


  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={name}
                   label={Dict('name')}
                   placeholder={Dict('name')}
                   onChange={(e) => {
                     setName(e.target.value)
                   }}
            />
            <Validator state={name} rules="required"/>
            <Validator state={name} rules="alphabetic"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={family}
                   label={Dict('family')}
                   placeholder={Dict('family')}
                   onChange={(e) => {
                     setFamily(e.target.value)
                   }}
            />
            <Validator state={family} rules="required"/>
            <Validator state={family} rules="alphabetic"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={fatherName}
                   label={Dict('father_name')}
                   placeholder={Dict('father_name')}
                   onChange={(e) => {
                     setFatherName(e.target.value)
                   }}
            />
            <Validator state={fatherName} rules="required"/>
            <Validator state={fatherName} rules="alphabetic"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={nationalCode}
                   label={Dict('national_code')}
                   placeholder={Dict('national_code')}
                   onChange={(e) => {
                     setNationalCode(e.target.value)
                   }}
            />
            <Validator state={nationalCode} rules="required"/>
            <Validator state={nationalCode} rules="num"/>
          </div>

          <div className="flex w-full mb-4">
            <DateField
              className="my-4 mx-4 w-full"
              date={birthDate}
              setDate={setBirthDate}
              label={Dict("birth_date")}
            />
            <Validator state={birthDate} rules="required"/>
          </div>

          <div className="flex w-full mb-4">
            <Select variant="static" className="rtl" style={{label: {left: ""}}}
                    label={Dict('gender')}
                    value={gender}
                    onChange={(val) => setGender(val)}>
              <Option value="male">مرد</Option>
              <Option value="female">زن</Option>
            </Select>
          </div>

        </div>
        <div className="justify-between">
          <div className="mt-32 flex justify-between">
            <Button onClick={save} disabled={isLastStep}>
              مرحله بعدی
            </Button>
            <Button onClick={() => {
              handlePrev(0)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
      </>
    </ValidatorProvider>
  )
    ;
}